import React from 'react'
import ReactPaginate from 'react-paginate';
// import { LeftArrowSvg } from '../../../svgFiles/LeftArrowSvg.jsx';
const Pagination = ({ totalPages, onPageChange, currentPage }) => {


  return (
    <div className='pagination'>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={(e) => { onPageChange(e.selected + 1) }}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        previousLabel="<"
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
      />
    </div>
  )
}

export default Pagination